export default "__VITE_ASSET__BV$1jqBA__"